export function removeMarkdown(markdown: string | null | undefined): string {
	if (!markdown) {
		return ''; // Handle the case where markdown is null or undefined
	}

	// Convert headers to plain text
	markdown = markdown.replace(/^#+\s*(.+?)\s*$/gm, '$1');

	// Convert bold and italic text to plain text
	markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
	markdown = markdown.replace(/__(.+?)__/g, '$1');
	markdown = markdown.replace(/\*(.+?)\*/g, '$1');
	markdown = markdown.replace(/_(.+?)_/g, '$1');

	// Convert strikethrough text to plain text
	markdown = markdown.replace(/~~(.+?)~~/g, '$1');

	// Remove code blocks first (before inline code, since ``` contains `)
	// Remove complete code blocks with closing ```
	markdown = markdown.replace(/```[\s\S]*?```/g, '');
	// Remove any remaining unclosed code block markers
	markdown = markdown.replace(/```/g, '');

	// Convert inline code to plain text (after code blocks are removed)
	markdown = markdown.replace(/`(.+?)`/g, '$1');

	// Break up == with zero-width space to prevent markdown-to-jsx from parsing it as <mark>
	// This preserves the visual appearance of == (common in code like ===, !==, ==)
	// while preventing the parser from hanging on malformed mark syntax
	const ZERO_WIDTH_SPACE = '\u200B';
	markdown = markdown.replace(/==/g, `=${ZERO_WIDTH_SPACE}=`);

	// Convert links to plain text by keeping only the link text
	markdown = markdown.replace(/\[(.+?)\]\((.+?)\)/g, '$1');

	// Convert autolinks to plain text
	markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>/g, '$1');

	// Handle autolinks with display text, like <http://example.com|example.com>
	markdown = markdown.replace(/<([^|>]+)\|([^>]+)>/g, '$2');

	// Fix broken autolinks
	markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>?/g, '$1');

	// Remove images, keeping only the alt text
	markdown = markdown.replace(/!\[(.+?)\]\((.+?)\)/g, '$1');

	// Remove blockquotes, preserving the quoted text
	markdown = markdown.replace(/^\s*>\s+(.+?)\s*$/gm, '$1');

	// Preserve list items as plain text, removing the list markers
	markdown = markdown.replace(/^\s*[\*\+-]\s+(.+?)\s*$/gm, '$1');
	markdown = markdown.replace(/^\s*\d+\.\s+(.+?)\s*$/gm, '$1');

	// Remove horizontal lines
	markdown = markdown.replace(/^\s*[-*_]{3,}\s*$/gm, '');

	// Replace multiple newlines with a single newline
	markdown = markdown.replace(/\n\s*\n/g, '\n');

	return markdown.trim();
}
